import { reversalItems } from "@/mocks/gua";

export default function ReversalField() {
  return (
    <section
      id="reversal"
      className="scroll-mt-28 bg-background-100/70"
    >
      <div className="mx-auto max-w-6xl px-4 py-16 md:px-6 md:py-20">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <p className="text-xs font-medium tracking-[0.3em] text-accent-700">02 / 翻车实录</p>
            <h2 className="mt-3 font-display text-3xl font-black tracking-tight text-foreground-950 md:text-4xl">
              翻车实录
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
              不追新梗，只做冷复盘：把高光到翻车的每一步拆开，看清裂缝最早出现在哪一格。
            </p>
          </div>
          <span className="whitespace-nowrap text-xs text-foreground-500">按月归档 · 长期复盘栏目</span>
        </div>

        <div className="mt-10 flex flex-col gap-6">
          {reversalItems.map((r) => (
            <article
              key={r.id}
              className="group grid grid-cols-1 overflow-hidden rounded-lg border border-background-200 bg-background-50 lg:grid-cols-5"
            >
              <div className="relative min-h-[220px] overflow-hidden bg-background-100 lg:col-span-2 lg:min-h-0">
                <img
                  src={r.image}
                  alt={`吃瓜黑网翻车实录：${r.subject}`}
                  title={`${r.subject} 翻车全程复盘`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105 lg:absolute lg:inset-0"
                />
                <span className="absolute left-4 top-4 font-display text-5xl font-black text-background-50 mix-blend-overlay">
                  {r.order}
                </span>
              </div>

              <div className="flex flex-col p-6 lg:col-span-3 lg:p-8">
                <p className="text-xs tracking-widest text-accent-700">{r.subtitle}</p>
                <h3 className="mt-2 font-display text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
                  {r.subject}
                </h3>

                <ul className="mt-5 flex flex-col gap-2.5">
                  {r.stages.map((s, idx) => (
                    <li key={s} className="flex items-start gap-3 text-sm text-foreground-700">
                      <span
                        className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full text-[11px] font-semibold ${
                          idx === 2
                            ? "bg-primary-500 text-background-50"
                            : "bg-secondary-100 text-secondary-900"
                        }`}
                      >
                        {idx + 1}
                      </span>
                      <span className="leading-relaxed">{s}</span>
                    </li>
                  ))}
                </ul>

                <p className="mt-5 border-l-2 border-accent-500 pl-3 text-sm italic leading-relaxed text-foreground-600">
                  {r.lesson}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}